import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-community';

@Component({
    selector: 'app-custom-loading-overlay',
    templateUrl: './custom-loading-overlay.component.html',
    styleUrls: ['./custom-loading-overlay.component.scss'],
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CustomLoadingOverlayComponent implements OnInit, ILoadingOverlayAngularComp {
  @Input() timeOutLoading: boolean = false;
  public params!: ILoadingOverlayParams & { loadingMessage: string };
  public timeoutErrorIcon: string;

  constructor() {}

  ngOnInit(): void {}

  agInit(params: ILoadingOverlayParams & { loadingMessage: string }): void {
    this.params = params;
  }
}
